import axios from "axios";
var CryptoJS = require("crypto-js");

class dataApi {
    constructor() {
        this.URL = "https://" + process.env.VUE_APP_MAIN_URL + "/api";
        this.cryptageKey = "2687da56-4181-48a6-bec4-c526727423f8"
    }

    encrypt(datas) {
        return { data: CryptoJS.AES.encrypt(JSON.stringify(datas), this.cryptageKey).toString() }
    }

    decrypt(data) {
        var bytes = CryptoJS.AES.decrypt(data, this.cryptageKey);
        var originalData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return originalData
    }

    user_login(email, password, callback) {
        let datas = { email, password }
        axios.post(this.URL + '/v1/user_login', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_user_by_token(token, callback) {
        let datas = { token }
        axios.post(this.URL + '/v1/get_user_by_token', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_contrat_from_num_contrat(numContrat, callback) {
        let datas = { numContrat }
        axios.post(this.URL + '/v1/get_contrat_from_num_contrat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_societe_by_id(id, callback) {
        let datas = { id }
        axios.post(this.URL + '/v1/get_societe_by_id', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_societe_by_id_soft(id, callback) {
        let datas = { id }
        axios.post(this.URL + '/v1/get_societe_by_id_soft', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    run_conge_function(fctName, params, callback) {
        console.log("run_conge_function");
        let datas = { fctName, params }
        axios.post(this.URL + '/v1/run_conge_function', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_solde_by_user_id(user_id, callback) {
        let datas = { user_id }
        axios.post(this.URL + '/v1/get_solde_by_user_id', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_conge_by_user_id(user_id, callback) {
        let datas = { user_id }
        axios.post(this.URL + '/v1/get_conge_by_user_id', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_agency(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_agency', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    create_demande_conge(requeste, callback) {
        let datas = { requeste }
        axios.post(this.URL + '/v1/create_demande_conge', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    update_conge_statut(id_demande, statut, callback) {
        let datas = { id_demande, statut }
        axios.post(this.URL + '/v1/update_conge_statut', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_all_users(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_all_users', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_conge_type(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_conge_type', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_agency_soft(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_agency_soft', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    update_solde(recordId, fields, callback) {
        let datas = { recordId, fields }
        axios.post(this.URL + '/v1/update_solde', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_clients(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_clients', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

}

export default new dataApi()